import { render, staticRenderFns } from "./GestorCentralizadoPenalidadModal.vue?vue&type=template&id=500b5fbd&"
import script from "./GestorCentralizadoPenalidadModal.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoPenalidadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports